import { render, staticRenderFns } from "./signature-box.component.vue?vue&type=template&id=76f0921a&scoped=true"
import script from "./signature-box.component.vue?vue&type=script&lang=js"
export * from "./signature-box.component.vue?vue&type=script&lang=js"
import style0 from "./signature-box.component.vue?vue&type=style&index=0&id=76f0921a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f0921a",
  null
  
)

export default component.exports